import { render } from "./Cortes.vue?vue&type=template&id=a9d7ae1a&scoped=true"
import script from "./Cortes.vue?vue&type=script&lang=js"
export * from "./Cortes.vue?vue&type=script&lang=js"

import "./Cortes.vue?vue&type=style&index=0&id=a9d7ae1a&scoped=true&lang=css"

import exportComponent from "G:\\Centrion\\projetos\\vue\\sisDemode\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a9d7ae1a"]])

export default __exports__